import { styled } from '@volkswagen-onehub/components-core';
import { COLOR_TOKEN } from 'src/components/color-token';

export const WhiteLinkWrapper = styled.span`
	a {
		color: ${COLOR_TOKEN.main.content.inverted};
		font-weight: bold;
	}
`;
